var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomAiDevelopmentWhatItIncludesAndWhatItCosts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1376 768",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Custom AI development cost ranges and timelines by project shape",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1376,
    height: 768,
    fill: "#1B1424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Outfit, Poppins, 'Segoe UI', Helvetica, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 110,
    fontSize: 15,
    fontWeight: 600,
    fill: "#B47CFD",
    textAnchor: "start",
    letterSpacing: 2.4,
    opacity: 1
  }, "CUSTOM AI DEVELOPMENT \xB7 2026 COST BANDS"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 164,
    fontSize: 36,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "What each shape of build costs, and how long it takes"), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 230,
    x2: 520,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$0k"), /*#__PURE__*/React.createElement("line", {
    x1: 605.7142857142857,
    y1: 230,
    x2: 605.7142857142857,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 605.7142857142857,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$10k"), /*#__PURE__*/React.createElement("line", {
    x1: 691.4285714285714,
    y1: 230,
    x2: 691.4285714285714,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 691.4285714285714,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$20k"), /*#__PURE__*/React.createElement("line", {
    x1: 777.1428571428571,
    y1: 230,
    x2: 777.1428571428571,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 777.1428571428571,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$30k"), /*#__PURE__*/React.createElement("line", {
    x1: 862.8571428571429,
    y1: 230,
    x2: 862.8571428571429,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 862.8571428571429,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$40k"), /*#__PURE__*/React.createElement("line", {
    x1: 948.5714285714286,
    y1: 230,
    x2: 948.5714285714286,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 948.5714285714286,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$50k"), /*#__PURE__*/React.createElement("line", {
    x1: 1034.2857142857142,
    y1: 230,
    x2: 1034.2857142857142,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1034.2857142857142,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$60k"), /*#__PURE__*/React.createElement("line", {
    x1: 1120,
    y1: 230,
    x2: 1120,
    y2: 590,
    stroke: "#2A2036",
    strokeWidth: 1,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1120,
    y: 616,
    fontSize: 13,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$70k"), /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 276,
    fontSize: 16,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "end",
    letterSpacing: 0,
    opacity: 1
  }, "AI feature in an existing product"), /*#__PURE__*/React.createElement("line", {
    x1: 562.8571428571429,
    y1: 270,
    x2: 652.8571428571429,
    y2: 270,
    stroke: "#3E2E55",
    strokeWidth: 10,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 562.8571428571429,
    cy: 270,
    r: 11,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652.8571428571429,
    cy: 270,
    r: 11,
    fill: "#E0775B",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 562.8571428571429,
    y: 250,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$5k"), /*#__PURE__*/React.createElement("text", {
    x: 652.8571428571429,
    y: 250,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$15.5k"), /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 276,
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFB454",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "4\u20138 weeks"), /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 362,
    fontSize: 16,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "end",
    letterSpacing: 0,
    opacity: 1
  }, "AI-native application from scratch"), /*#__PURE__*/React.createElement("line", {
    x1: 652.8571428571429,
    y1: 356,
    x2: 897.1428571428571,
    y2: 356,
    stroke: "#3E2E55",
    strokeWidth: 10,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 652.8571428571429,
    cy: 356,
    r: 11,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.1428571428571,
    cy: 356,
    r: 11,
    fill: "#E0775B",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 652.8571428571429,
    y: 336,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$15.5k"), /*#__PURE__*/React.createElement("text", {
    x: 897.1428571428571,
    y: 336,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$44k"), /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 362,
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFB454",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "8\u201316 weeks"), /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 448,
    fontSize: 16,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "end",
    letterSpacing: 0,
    opacity: 1
  }, "Agents &amp; automation across systems"), /*#__PURE__*/React.createElement("line", {
    x1: 627.1428571428571,
    y1: 442,
    x2: 871.4285714285714,
    y2: 442,
    stroke: "#3E2E55",
    strokeWidth: 10,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 627.1428571428571,
    cy: 442,
    r: 11,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871.4285714285714,
    cy: 442,
    r: 11,
    fill: "#E0775B",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 627.1428571428571,
    y: 422,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$12.5k"), /*#__PURE__*/React.createElement("text", {
    x: 871.4285714285714,
    y: 422,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$41k"), /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 448,
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFB454",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "6\u201314 weeks"), /*#__PURE__*/React.createElement("text", {
    x: 492,
    y: 534,
    fontSize: 16,
    fontWeight: 600,
    fill: "#F5F5F5",
    textAnchor: "end",
    letterSpacing: 0,
    opacity: 1
  }, "Enterprise platform \xB7 private hosting \xB7 SSO"), /*#__PURE__*/React.createElement("line", {
    x1: 897.1428571428571,
    y1: 528,
    x2: 1120,
    y2: 528,
    stroke: "#3E2E55",
    strokeWidth: 10,
    opacity: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 897.1428571428571,
    cy: 528,
    r: 11,
    fill: "#B47CFD",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 528,
    r: 11,
    fill: "#E0775B",
    stroke: "none",
    strokeWidth: 1,
    opacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 897.1428571428571,
    y: 508,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$44k"), /*#__PURE__*/React.createElement("text", {
    x: 1120,
    y: 508,
    fontSize: 13,
    fontWeight: 700,
    fill: "#F5F5F5",
    textAnchor: "middle",
    letterSpacing: 0,
    opacity: 1
  }, "$70k+"), /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 534,
    fontSize: 15,
    fontWeight: 600,
    fill: "#FFB454",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "3\u20136 months"), /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 240,
    fontSize: 12,
    fontWeight: 800,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 2,
    opacity: 1
  }, "TIMELINE"), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 668,
    fontSize: 14,
    fontWeight: 400,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 0,
    opacity: 1
  }, "Running costs are separate: inference scales with usage; refresh and maintenance run 10\u201320% of build cost a year."), /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 712,
    fontSize: 16,
    fontWeight: 600,
    fill: "#B0A8C0",
    textAnchor: "start",
    letterSpacing: 3,
    opacity: 1
  }, "WORKFLOX"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAiDevelopmentWhatItIncludesAndWhatItCosts);
export default __webpack_public_path__ + "static/media/custom-ai-development-what-it-includes-and-what-it-costs.25916c036ba7ff22c61e34bac4006d39.svg";
export { ForwardRef as ReactComponent };